__turbopack_context__.v({
  "body": "Salutation-module__O41Iuq__body",
  "header": "Salutation-module__O41Iuq__header",
  "layer": "Salutation-module__O41Iuq__layer",
  "links": "Salutation-module__O41Iuq__links",
  "mention": "Salutation-module__O41Iuq__mention",
  "name": "Salutation-module__O41Iuq__name",
  "pulseSlot": "Salutation-module__O41Iuq__pulseSlot",
  "root": "Salutation-module__O41Iuq__root",
  "stack": "Salutation-module__O41Iuq__stack",
});
